<template>
  <el-form class="remark-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        <span class="require-flag">*</span>
        内容
      </template>
      <rich-input v-model="control.hint"></rich-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">整行宽度</template>
      <el-checkbox v-model="control.wholeLine"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import RichInput from "@/components/FormControl/RichInput"
export default {
  name: "remark-control",
  components: { RichInput },
  props: {
    control: Object
  }
}
</script>

<style lang="scss" scoped></style>
